import Cost from 'components/containers/Cost';
import DefaultLayout from 'layouts/Default';
import LoginLogoutLayout from 'layouts/LoginLogout';
import withTilstandsrapport from 'lib/withTilstandsrapport';
import { NextPage } from 'next';
import Head from 'next/head';
import React from 'react';
import { connect } from 'react-redux';
import { AppState } from 'store';
import { getAddress } from 'store/tilstandsrapportEntities/tilstandsrapport/selectors';

interface Props {
  tilstandsrapportId: string;
}

interface StateProps {
  address: string;
}

const PageItem: NextPage<Props> = ({ address, tilstandsrapportId }: Props & StateProps) => {
  return (
    <LoginLogoutLayout>
      <Head>
        <title>{`${address} - Vendu Smart Boliganalyse - Hva koster det å bo her?`}</title>
      </Head>
      <Cost tilstandsrapportId={tilstandsrapportId} />
    </LoginLogoutLayout>
  );
};

const mapStateToProps = (state: AppState, ownProps): StateProps => ({
  address: getAddress(state, ownProps.tilstandsrapportId),
});

export default withTilstandsrapport(
  connect(
    mapStateToProps,
    null,
  )(PageItem),
);
